import { AnimatePresence, motion } from 'motion/react';

import { SHIMMER_TEXT_CLASSES } from '@/components/blocks/Message/reasoning/ShimmerCollapsibleHeader';
import { cn } from '@/lib/utils';

interface SlotMachineTextProps {
  text: string;
  textClassName?: string;
}

export const SlotMachineText = ({
  text,
  textClassName,
}: SlotMachineTextProps) => (
  <span className="relative block h-5 w-full overflow-hidden">
    <AnimatePresence initial={false}>
      <motion.span
        key={text}
        initial={{ y: '110%', opacity: 0 }}
        animate={{ y: '0%', opacity: 1 }}
        exit={{ y: '-110%', opacity: 0 }}
        transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
        className={cn(
          'absolute inset-x-0 top-0 block truncate text-sm leading-5',
          'bg-clip-text text-transparent',
          ...SHIMMER_TEXT_CLASSES,
          textClassName
        )}
      >
        {text}
      </motion.span>
    </AnimatePresence>
  </span>
);
